import Vue from 'vue'
import App from '@/components/App.vue'
import store from '@/store/store'
import router from '@/routes/routes'
import { language } from '@/languages/language'
import spinner from '@/plugins/spinner/spinnerBlock'
import confirmation from '@/plugins/confirmation/confirmation'
import toast from '@/plugins/toast/configToastr'
import datatable from '@/plugins/datatables/datatable.js'
import googleMap from '@/vue/directives'
import utcToDate from '@/vue/filters'
import SDateTimePicker from '@/components/layout/datetimepicker/DateTimePicker.vue'
import SSelect2 from '@/plugins/select2/select2.vue'
import VueFormWizard from 'vue-form-wizard'
import 'vue-form-wizard/dist/vue-form-wizard.min.css'
import VTooltip from 'v-tooltip'
import IdleVue from 'idle-vue'
import VueApexCharts from 'vue-apexcharts'

Vue.use(datatable)
Vue.use(VueFormWizard)
Vue.use(VueApexCharts)
Vue.component('apexchart', VueApexCharts)
Vue.component('s-select2', SSelect2)
Vue.component('s-date-time-picker', SDateTimePicker)

Vue.filter('utcToDate', utcToDate)

Vue.directive('map', googleMap)

Vue.use(VTooltip)

const eventsHub = new Vue()

Vue.use(IdleVue, {
  eventEmitter: eventsHub,
  idleTime: 30000000
})

Vue.config.productionTip = false
Vue.config.devtools = false
Vue.config.debug = false
Vue.config.silent = true
document.addEventListener('DOMContentLoaded', () => {
  language.initialize(store)
  Vue.use(spinner, { language })
  Vue.use(toast, { language })
  Vue.use(confirmation, { language })
  new Vue({
    render: h => h(App),
    store,
    router,
    i18n: language.i18n,
    data () {
      return {
        messageStr: ''
      }
    },
    onIdle () {
      this.messageStr = 'Cierre de sesión por inactividad'
      console.log(this.messageStr)
      this.logout()
    },
    methods: {
      logout () {
        this.$store.dispatch('postLogout')
        this.$store.state.authentication.logged_in = false
        localStorage.removeItem('logged_in')
        localStorage.removeItem('user_email')
        localStorage.removeItem('user_data')
        localStorage.removeItem('user_shard')
        localStorage.removeItem('sections')
        this.$store.commit('addSections', [])
        this.$router.push({ name: 'login' })
      }
    }
  }).$mount('#app')
})



// WEBPACK FOOTER //
// app/javascript/src/main.js